import { MainContentLayout } from 'shared/ui/layout';

import { AddBank } from 'features/bank/add';

export function AddBankPage() {
  return <MainContentLayout element={<AddBank />} />;
}
